<template>
  <div class="myOrd">
    <header>
      <van-sticky :offset-top="-1">
        <div class="searchBox">
          <div class="search" @click="searchClick">
            <div class="searchicon">
              <van-icon name="search" />
            </div>
            <div class="inp">订单号、收件人、商品名称</div>
          </div>
        </div>
        <ul class="bg-F">
          <li
            @click="navFn(item)"
            :class="{ colorLis: navClick == item.id }"
            v-for="item in nav"
            :key="index"
          >
            {{ item.tag }}
          </li>
        </ul>
      </van-sticky>
    </header>
    <Scroller
      v-if="!empty"
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      ref="my_scroller"
    >
      <div class="list">
        <ul v-if="navClick != 4">
          <li v-for="(item, index) of list" :key="index">
            <p>
              <span>
                <b>{{ item.order_from }}</b>
                <b>
                  {{ item.no }}
                  <img v-if="item.isoversea == 1" src="../../assets/images/haiwai.png" />
                  <img v-if="item.issplit == 1" src="../../assets/images/chai.png" />
                </b>
              </span>
              <b>
                <i class="flex">
                  {{ item.orderstatus_text }}
                  <span
                    class="color-FC0324"
                    v-if="item.isGroupOrder == 1 && item.groupJoinNum > 0 && item.orderstatus == 2"
                  >
                    {{ `(还差${item.groupJoinNum}人拼团成功)` }}
                  </span>
                </i>
                <b
                  v-if="
                    item.orderstatus == 0 ||
                    item.orderstatus == 3 ||
                    item.orderstatus == 6 ||
                    item.orderstatus == 5
                  "
                  @click="deleteFn(item, index)"
                >
                  <img src="../../assets/images/delete1.png" />
                </b>
              </b>
            </p>
            <div class="product" @click="detailsClick(item)">
              <div
                v-if="item.itemlist && item.itemlist.length <= 1 && item.itemlist.length > 0"
                class="productBox"
              >
                <div class="img">
                  <img v-lazy="item.itemlist[0].img_path" />
                  <goods-tag :goods="item.itemlist[0]"></goods-tag>
                </div>
                <div class="proContent">
                  <b>
                    {{
                      item.itemlist[0].name.length > 26
                        ? item.itemlist[0].name.slice(0, 26) + '...'
                        : item.itemlist[0].name
                    }}
                  </b>
                  <p>
                    <b>{{ item.itemlist[0].spec }}</b>
                  </p>
                </div>
              </div>
              <div
                v-if="item.itemlist && item.itemlist.length > 1"
                class="bestSellingSwiper over-h pos-r"
              >
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(itemSon, idx) of item.itemlist" :key="idx">
                    <div class="img">
                      <!--                    <div class="tag" v-if="itemSon.ispresale == 1">-->
                      <!--                      <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>-->
                      <!--                    </div>-->
                      <img v-lazy="itemSon.img_path" />
                      <goods-tag :goods="itemSon"></goods-tag>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <span
                class="totalPrice"
                :style="
                  item && item.itemlist && item.itemlist.length > 1 ? {} : { position: 'static' }
                "
                :class="{
                  totalPriceNoShadow: item.itemlist && item.itemlist.length < 4,
                  totalPriceShadow: item.itemlist && item.itemlist.length >= 4
                }"
              >
                <span class="price">
                  {{
                    String(parseFloat(item.ordermoney).toFixed(2)).slice(
                      0,
                      String(parseFloat(item.ordermoney).toFixed(2)).indexOf('.')
                    )
                  }}
                  <i>
                    {{
                      String(parseFloat(item.ordermoney).toFixed(2)).slice(
                        String(parseFloat(item.ordermoney).toFixed(2)).indexOf('.'),
                        String(parseFloat(item.ordermoney).toFixed(2)).length
                      )
                    }}
                  </i>
                </span>
                <b>共{{ item.item_nums }}件</b>
              </span>
            </div>
            <div class="proFooter">
              <div
                class="p q"
                :class="{ spread: spread == index || item.presalepopup.length == 1 }"
                v-if="item.presalepopup && item.presalepopup.length"
              >
                <p
                  @click.stop="isSpreadFn(index)"
                  :class="{ spread: spread == index || item.presalepopup.length == 1 }"
                  v-for="(itemPresell, indexPresell) of item.presalepopup"
                >
                  <span>{{ itemPresell }}</span>
                  <van-icon
                    v-if="indexPresell == 0 && item.presalepopup.length > 1"
                    color="#B7B7B7"
                    :name="spread == index ? 'arrow-up' : 'arrow-down'"
                  />
                </p>
              </div>
              <div class="p">
                <p
                  class="jc-fs"
                  :class="'countDown' + index"
                  v-if="item.orderstatus == 1 && item.isdeposit == 1 && item.finalpaystatus == 0"
                >
                  {{ dateFn(item.finalpaymenttime, 'datetimestr') }}开始付尾款
                </p>
                <p
                  class="jc-fs"
                  :class="'countDown' + index"
                  v-if="item.orderstatus == 1 && item.isdeposit == 1 && item.finalpaystatus == 1"
                >
                  {{ dateFn(item.finalpaymenttime, 'datetimestr') }}截止付尾款
                </p>
                <p
                  class="jc-fs subscribe"
                  :class="'countDown' + index"
                  v-if="
                    item.orderstatus == 1 &&
                    item.issubscribeorder == 1 &&
                    item.subscribepaystatus == 0
                  "
                >
                  <img src="/static/wx/img/20220308/Booking-activities@2x.png" />
                  &nbsp;&nbsp;距离支付时间还剩：
                  <van-count-down
                    @finish="finish(index)"
                    :time="item.time"
                    format="DD天HH时mm分ss秒"
                  />
                </p>
                <p
                  class="jc-fs"
                  :class="'countDown' + index"
                  v-if="
                    item.orderstatus == 1 && item.isdeposit != 1 && item.subscribepaystatus != 0
                  "
                >
                  剩
                  <van-count-down
                    @finish="finish(index)"
                    :time="item.time"
                    format="HH 时 mm 分 ss 秒"
                  />
                  关闭交易
                </p>
                <p class="jc-fs" v-if="item.areaException == 1">
                  <img
                    class="mr3"
                    style="width: 0.14rem; height: 0.14rem"
                    src="../../assets/images/presell.png"
                  />
                  订单地址异常，无法正常发货
                </p>
                <p
                  class="jc-fs ws-w"
                  v-if="item.isGroupOrder == 1 && item.groupJoinNum > 0 && item.orderstatus == 2"
                >
                  如果订单未拼成功，将自动退款
                </p>
              </div>
              <div class="proBtn">
                <!--发起拼团分享-->
                <button
                  v-if="item.isGroupOrder == 1 && item.groupJoinNum > 0 && item.orderstatus == 2"
                  class="redBtn"
                  @click="groupShare(item)"
                >
                  邀请好友购买
                </button>
                <button
                  v-if="item.areaException == 1 && item.time == 0"
                  class="grayBtn"
                  @click.stop="keFu(item)"
                >
                  联系客服
                </button>
                <button
                  v-if="item.relationorders && item.relationorders.length > 0"
                  class="grayBtn"
                  @click.stop="relationordersFn(item)"
                >
                  补发订单
                </button>
                <button
                  v-if="
                    ((item.isdeposit != 1 && item.issubscribeorder != 1) ||
                      ((item.isdeposit == 1 || item.issubscribeorder == 1) &&
                        item.isvirtual == 0)) &&
                    item.orderstatus == 1
                  "
                  class="grayBtn"
                  @click="cancelFn(item)"
                >
                  取消订单
                </button>
                <button
                  v-if="(item.orderstatus == 2 && item.status != 2) || item.orderstatus == 7"
                  class="grayBtn"
                  @click="checkTrans(item)"
                >
                  查看物流
                </button>
                <button
                  v-if="
                    (item.orderstatus == 3 || item.orderstatus == 6) &&
                    item.iscomment == 0 &&
                    item.is_act_order == 0
                  "
                  class="grayBtn"
                  @click="detailsClick(item)"
                >
                  评价晒单
                </button>
                <!--与app不一致-->
                <button
                  v-if="
                    ((item.isdeposit != 1 && item.issubscribeorder != 1) ||
                      (item.issubscribeorder == 1 && item.subscribepaystatus == 1) ||
                      (item.isdeposit == 1 && item.isvirtual == 0)) &&
                    item.orderstatus == 1
                  "
                  class="redBtn"
                  @click="goBuy(item)"
                >
                  去支付
                </button>
                <button
                  v-if="item.isdeposit == 1 && item.isvirtual == 1 && item.orderstatus == 1"
                  class="redBtn"
                  :class="{ grayBtn: item.finalpaystatus == 0 }"
                  @click="goBuy(item)"
                >
                  支付尾款{{ parseFloat(item.finalpaymoney).toFixed(2) }}元
                </button>
                <button
                  v-if="(item.orderstatus == 2 && item.status != 2) || item.orderstatus == 7"
                  class="redBtn"
                  @click="confirm(item, index)"
                >
                  确认收货
                </button>
                <button
                  v-if="
                    (item.orderstatus == 2 ||
                      item.orderstatus == 3 ||
                      item.orderstatus == 6 ||
                      item.orderstatus == 7) &&
                    item.changebuystatus
                  "
                  class="redBtn"
                  @click="goProductList(item)"
                >
                  去换购
                </button>
                <button
                  v-if="
                    (item.orderstatus == 2 ||
                      item.orderstatus == 3 ||
                      item.orderstatus == 6 ||
                      item.orderstatus == 7) &&
                    !item.changebuystatus &&
                    item.isexchange
                  "
                  class="redBtn"
                  @click="goProductList(item)"
                >
                  去加购
                </button>
                <button
                  v-if="
                    (item.orderstatus == 0 || item.orderstatus == 4 || item.orderstatus == 5) &&
                    item.is_act_order == 0 &&
                    item.isdeposit != 1 &&
                    item.issubscribeorder != 1 &&
                    item.isMayTwentyAct != 1
                  "
                  class="redBtn"
                  @click="buyAgain(item, 'order')"
                >
                  重新购买
                </button>
                <button
                  v-if="
                    (item.orderstatus == 3 || item.orderstatus == 6) &&
                    item.is_act_order == 0 &&
                    item.isdeposit != 1 &&
                    item.issubscribeorder != 1 &&
                    item.isMayTwentyAct != 1
                  "
                  class="redBtn"
                  @click="buyAgain(item, 'order')"
                >
                  再次购买
                </button>
                <button
                  v-if="item.showtrial == 1"
                  class="redBtn orangeBtn"
                  @click="$router.push('/applyrecord')"
                >
                  试用反馈
                </button>
              </div>
            </div>
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item, index) of list" :key="index">
            <p>
              <span>
                <b>{{ item.order_from }}</b>
                <b>
                  {{ item.order_no }}
                  <img v-if="item.isoversea == 1" src="../../assets/images/haiwai.png" />
                  <img v-if="item.issplit == 1" src="../../assets/images/chai.png" />
                </b>
              </span>
              <b>
                <i>{{ item.apply_status_text }}</i>
                <b
                  v-if="
                    item.orderstatus == 0 ||
                    item.orderstatus == 3 ||
                    item.orderstatus == 6 ||
                    item.orderstatus == 5
                  "
                  @click="deleteFn(item, index)"
                >
                  <img src="../../assets/images/delete1.png" />
                </b>
              </b>
            </p>
            <div class="product" @click="afterDetailsClick(item)">
              <div
                v-if="item.item_list && item.item_list.length <= 1 && item.item_list.length > 0"
                class="productBox"
              >
                <div class="img">
                  <!--                <div class="tag" v-if="item.item_list[0].ispresale == 1">-->
                  <!--                  <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>-->
                  <!--                </div>-->
                  <img v-lazy="item.item_list[0].img_path" />
                  <goods-tag :goods="item.item_list[0]"></goods-tag>
                </div>
                <div class="proContent">
                  <b>
                    {{
                      item.item_list[0].name.length > 26
                        ? item.item_list[0].name.slice(0, 26) + '...'
                        : item.item_list[0].name
                    }}
                  </b>
                  <p>
                    <b>{{ item.item_list[0].spec }}</b>
                  </p>
                </div>
              </div>
              <div
                v-if="item.item_list && item.item_list.length > 1"
                class="bestSellingSwiper over-h pos-r"
              >
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(itemSon, idx) of item.item_list" :key="idx">
                    <div class="img">
                      <!--                    <div class="tag" v-if="itemSon.ispresale == 1">-->
                      <!--                      <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>-->
                      <!--                    </div>-->
                      <img v-lazy="itemSon.img_path" />
                      <goods-tag :goods="itemSon"></goods-tag>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <span
                class="totalPrice"
                :style="
                  item && item.item_list && item.item_list.length > 1 ? {} : { position: 'static' }
                "
                :class="{
                  totalPriceNoShadow: item.item_list && item.item_list.length < 4,
                  totalPriceShadow: item.item_list && item.item_list.length >= 4
                }"
              >
                <span class="price">
                  {{
                    String(parseFloat(item.totalmoney).toFixed(2)).slice(
                      0,
                      String(parseFloat(item.totalmoney).toFixed(2)).indexOf('.')
                    )
                  }}
                  <i>
                    {{
                      String(parseFloat(item.totalmoney).toFixed(2)).slice(
                        String(parseFloat(item.totalmoney).toFixed(2)).indexOf('.'),
                        String(parseFloat(item.totalmoney).toFixed(2)).length
                      )
                    }}
                  </i>
                </span>
                <b>共{{ item.total }}件</b>
              </span>
            </div>
            <div class="proFooter">
              <div class="proBtn">
                <button class="grayBtn" @click="afterDetailsClick(item)">售后详情</button>
                <button
                  v-if="
                    item.is_act_order != 1 &&
                    item.isdeposit != 1 &&
                    item.issubscribeorder != 1 &&
                    item.isMayTwentyAct != 1
                  "
                  class="redBtn"
                  @click="buyAgain(item, 'after')"
                >
                  重新购买
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Scroller>
    <div class="empty" v-if="productlist && productlist.length > 0 && empty" ref="empty">
      <img src="../../assets/images/emptyorder.png" />
      <p>啊哦～您还没有相关订单</p>
    </div>
    <div
      ref="recommend"
      class="pt15 pb15 pl0 pr0"
      v-if="productlist && productlist.length > 0 && recommend"
    >
      <div class="pt0 pb0 pl10 pr10 bg-F">
        <product-list :title="title" :productlist="productlist"></product-list>
      </div>
    </div>
    <div
      class="empty emptyNoProduct"
      ref="empty"
      v-if="productlist && productlist.length <= 0 && empty"
    >
      <empty :path="'noOrder'"></empty>
    </div>
    <div class="homeBtn" v-if="!hideIndexFloat" @click="homeClick">
      <img src="/static/images/homebtn.png" />
    </div>
    <van-overlay :show="showshare" z-index="100">
      <div class="sharecontainer" v-if="showshare === true">
        <img src="../../assets/images/sharemc.png" />
        <van-button round plain type="danger" class="know" @click="showshare = false">
          我知道了
        </van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang, isWx, download_dialog, kefu } from '../../assets/common/js/config'
import { joinShare } from './js/methods'
import productList from '../common/productList'
import empty from '../emptypage/empty'
import Vue from 'vue'
import Scroller from '../common/Scroller'
import goodsTag from '../common/goodsTag'
import { Sticky, Tag } from 'vant'

Vue.use(Sticky)
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'myOrder',
  data() {
    return {
      // ceil: false,
      spread: null,
      empty: false,
      recommend: false,
      oldtop: null,
      now: null,
      timer: null,
      nav: [
        { tag: '全部', id: 0 },
        { tag: '待付款', id: 1 },
        { tag: '待发货', id: 5 },
        { tag: '待收货', id: 2 },
        { tag: '待评价', id: 3 },
        { tag: '退款/售后', id: 4 }
      ],
      navClick: 0,
      title: '精选好物',
      list: [],
      // img: ['http://devstaticfile.oss-cn-shanghai.aliyuncs.com/Uploads/files/20190827/o_1dj8efrl6ft2171ts617t28jhc.png', 'http://devstaticfile.oss-cn-shanghai.aliyuncs.com/Uploads/goods/201812/o_1cs4c0obd16om1hso89i140u1jkgc.jpg'],
      // list: [],
      productlist: [],
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      showshare: false
    }
  },
  components: {
    productList,
    empty,
    Scroller,
    [Tag.name]: Tag,
    goodsTag
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    hideIndexFloat() {
      return this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex === '0'
    }
  },
  created() {
    var url_p = this.$route.fullPath
    console.log(url_p, this.$route)
    if (url_p.indexOf('listType=') < 0) {
      url_p += (url_p.indexOf('?') >= 0 ? '&' : '?') + 'listType=2'
    }
    this.$router.replace(url_p)
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'myorder' })
    }
    if (this.$route.query.navid || this.$route.query.navid == 0) {
      this.$store.commit('ORDERLIST_NAVID', this.$route.query.navid)
    }
    this.navClick = this.$store.state.orderlistNavid
    // this.nowPage = 1
    // this.list = []
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.navClick = vm.$store.state.orderlistNavid
        vm.productlist = []
        vm.nowPage = 0
        vm.list = []
        vm.onInfinite()
      })
    } else {
      next((vm) => {
        // vm.empty = false
        // vm.recommend = false
        vm.navClick = vm.$store.state.orderlistNavid
        if (vm.$store.state.orderInitData == 1) {
          vm.$store.commit('ORDER_INIT_DATA', 0)
          // Object.assign(vm.$data, vm.$options.data())
          vm.productlist = []
          vm.nowPage = 0
          vm.onInfinite()
          if (vm && vm.$refs.my_scroller) {
            // 通过vm实例访问this
            setTimeout(function () {
              window.scrollTo(0, sessionStorage.askPositon, false)
            }, 100) // 同步转异步操作
          }
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  watch: {
    navClick(n) {
      this.$store.commit('ORDERLIST_NAVID', this.navClick)
      this.empty = false
      this.recommend = false
      this.productlist = []
      this.nowPage = 0
      this.list = []
      this.onInfinite()
    }
  },
  methods: {
    getData: function () {
      var url, afterUrl
      if (this.navClick == 0) {
        url =
          this.$ajax.getOrderList_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&status=' +
          99
      } else if (this.navClick != 4) {
        url =
          this.$ajax.getOrderList_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&status=' +
          this.navClick
      } else {
        afterUrl =
          this.$ajax.getRefundOrderList_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize
      }
      if (this.$route.query.actgroupid) {
        if (url) url += '&actgroupid=' + this.$route.query.actgroupid
        if (afterUrl) afterUrl += '&actgroupid=' + this.$route.query.actgroupid
      }
      var that = this
      if (that.navClick != 4) {
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            var nowTime = new Date().getTime()
            var futureTime = null
            if (that.nowPage == 1) {
              res.data.orderlist.map((item) => {
                if (item.orderstatus == 1) {
                  // 待付款
                  if (item.issubscribeorder == 1 && item.subscribepaystatus == 0) {
                    futureTime = that.parserDate(item.subscribepaymenttime).getTime()
                    item.time = futureTime - nowTime
                  } else if (item.order_time != '' && item.order_time != undefined) {
                    futureTime =
                      that.parserDate(item.order_time).getTime() +
                      parseInt(item.close_time) * 1000 * 60
                    item.time = futureTime - nowTime
                  }
                }
              })
              that.list = res.data.orderlist
              that.refresh = false
            } else {
              res.data.orderlist.map((item) => {
                if (item.orderstatus == 1) {
                  // 待付款
                  if (item.issubscribeorder == 1 && item.subscribepaystatus == 0) {
                    futureTime = that.parserDate(item.subscribepaymenttime).getTime()
                    item.time = futureTime - nowTime
                  } else if (item.order_time != '' && item.order_time != undefined) {
                    futureTime =
                      that.parserDate(item.order_time).getTime() +
                      parseInt(item.close_time) * 1000 * 60
                    item.time = futureTime - nowTime
                  }
                }
              })
              that.list = that.list.concat(res.data.orderlist)
            }
            if (that.list.length <= 0) {
              that.$customRequestAjax(recommendUrl).then((res) => {
                if (res.data.code === 200) {
                  that.productlist = res.data.itemlist
                  that.loading = false
                  that.finished = true
                  that.empty = true
                  that.recommend = true
                }
              })
            } else {
              that.loading = false
              that.empty = false
              that.recommend = false
              if (res.data.orderlist.length < that.pagesize) {
                that.finished = true
              } else {
                that.finished = false
              }
            }
          }
        })
      } else {
        that.$customRequestAjax(afterUrl).then((res) => {
          if (res.data.code === 200) {
            if (that.nowPage == 1) {
              that.list = res.data.orderlist
              that.refresh = false
            } else {
              that.list = that.list.concat(res.data.orderlist)
            }
            if (that.list.length <= 0) {
              that.$customRequestAjax(recommendUrl).then((res) => {
                if (res.data.code === 200) {
                  that.productlist = res.data.itemlist
                  that.loading = false
                  that.finished = true
                  that.empty = true
                  that.recommend = true
                }
              })
            } else {
              that.loading = false
              that.empty = false
              that.recommend = false
              if (res.data.orderlist.length < that.pagesize) {
                that.finished = true
              } else {
                that.finished = false
              }
            }
          }
        })
      }
    },
    /**拼团分享 */
    groupShare: function (item) {
      if (item.joinShare && Object.keys(item.joinShare).length) {
        /**加载小程序、h5分享信息 */
        joinShare({
          that: this,
          sharetitle: item.joinShare.sharetitle || '',
          sharedesc: item.joinShare.sharedesc || '',
          shareimg: item.joinShare.shareimg || '',
          id: item.groupRecordId || '',
          code: item.groupCode
        })
        /**加载小程序、h5分享遮罩、app分享交互 */
        joinShare({
          that: this,
          sharetitle: item.joinShare.sharetitle || '',
          sharedesc: item.joinShare.sharedesc || '',
          shareimg: item.joinShare.shareimg || '',
          id: item.groupRecordId || '',
          code: item.groupCode,
          isClick: 1
        })
      }
    },
    onRefresh() {
      this.refresh = true
      // this.finished = false
      this.nowPage = 1
      // this.list = []
      var that = this
      that.getData()
      // this.editorClick()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    },
    isSpreadFn: function (index) {
      if (this.spread == null) {
        this.spread = index
      } else {
        this.spread = null
      }
    },
    goBuy: function (items) {
      if (items.isoversea == 1 && isWx != 3) {
        download_dialog(this)
        return
      }
      this.$store.commit('ORDER_INIT_DATA', 1)
      if (items.is_coupon == 1) {
        window.location.href =
          './static/wx/html/20190820/buyCoupon/pay.html?orderId=' +
          items.id +
          '&m=' +
          items.ordermoney
      } else {
        let skuids = []
        items.itemlist.forEach(function (item) {
          skuids.push(item.skuid)
        })
        if (
          ((items.isdeposit == 1 && items.finalpaystatus == 1) ||
            (items.issubscribeorder == 1 && items.subscribepaystatus == 1)) &&
          items.isvirtual == 1
        ) {
          var that = this
          var shopConfirmResult = {
            skuidArr: [],
            itemNum: [],
            skuidArrOversea: [],
            from: 2,
            orderfrom: 1,
            itemNumOversea: [],
            totalmoney: items.finalpaymoney || items.ordermoney,
            totalnum: items.item_nums,
            liveId: [],
            roomId: [],
            LiveIdArrOversea: [],
            roomIdArrOversea: [],
            ysorderid: items.no
          }
          if (items.issubscribeorder == 1 && items.subscribepaystatus == 1) {
            shopConfirmResult = {
              skuidArr: [],
              from: 2,
              orderfrom: 3,
              itemNum: [],
              totalmoney: items.ordermoney,
              totalnum: items.item_nums,
              liveId: [],
              roomId: []
            }
          }
          items.itemlist.forEach(function (item) {
            shopConfirmResult.skuidArr.push(item.skuid)
            shopConfirmResult.itemNum.push(item.num)
            shopConfirmResult.liveId.push(item.live_id ? item.live_id : '0')
            shopConfirmResult.roomId.push(item.room_id ? item.room_id : '0')
          })
          var urlCheck =
            that.$ajax.checkOrder_URL +
            '?skuids=' +
            shopConfirmResult.skuidArr.join() +
            '&buynum=' +
            shopConfirmResult.itemNum.join()
          if (items.issubscribeorder == 1 && items.subscribepaystatus == 1) {
            urlCheck =
              that.$ajax.checkOrder_URL +
              '?skuids=' +
              shopConfirmResult.skuidArr.join() +
              '&buynum=' +
              shopConfirmResult.itemNum.join() +
              '&type=2'
          }
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code == 200) {
              console.log(shopConfirmResult)
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              that.$router.push({ path: '/order', query: that.groupQuery() })
            }
          })
        } else if (items.is_drainage == 1) {
          this.$router.push({
            path: '/pay',
            query: this.groupQuery({
              id: items.id,
              money: items.ordermoney,
              yl: 1,
              ann: 1,
              anncc: 1,
              skuids: JSON.stringify(skuids)
            })
          })
        } else {
          if (items.isdeposit == 1) {
            if (items.finalpaystatus == 0) return
            this.$router.push({
              path: '/pay',
              query: this.groupQuery({
                id: items.id,
                money: items.ordermoney,
                skuids: JSON.stringify(skuids)
              })
            })
          } else {
            this.$router.push({
              path: '/pay',
              query: this.groupQuery({
                id: items.id,
                money: items.ordermoney,
                skuids: JSON.stringify(skuids)
              })
            })
          }
        }
      }
    },
    finish: function (id) {
      this.list[id].time = 0
      $('.countDown' + id).css('display', 'none')
    },
    parserDate: function (date) {
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    deleteFn: function (items, id) {
      var url = this.$ajax.deleteOrder_URL
      var data = {
        id: this.navClick != 4 ? items.id : items.order_id
      }
      if (this.navClick == 4) data.refundid = items.id
      var that = this
      this.$dialog
        .confirm({
          message: '确认删除订单？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        })
        .then(function () {
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.list.splice(id, 1)
            }
          })
        })
        .catch(function () {
          // on cancel
        })
    },
    keFu: function (items) {
      var goodslist = [],
        goodsnum = 0,
        money
      items.itemlist.map((item) => {
        goodslist.push({
          name: item.name,
          pictureUrl: encodeURIComponent(item.img_path)
        })
        goodsnum += parseInt(item.num)
      })
      money = parseFloat(items.ordermoney).toFixed(2)
      var k =
        'order_status=0&status_custom=' +
        items.orderstatus_text +
        '&create_time=' +
        new Date(items.order_time.replace(/-/g, '/')).getTime() +
        '&order_code=' +
        items.no +
        '&order_url=' +
        encodeURIComponent(window.location.href) +
        '&goods_count=' +
        goodsnum +
        '&total_fee=' +
        parseInt(parseFloat(money) * 100) +
        '&goods=' +
        JSON.stringify(goodslist)
      kefu(1, k)
    },
    relationordersFn: function (items) {
      if (items.relationorders && items.relationorders.length > 1) {
        this.$router.push({
          path: '/relationorders',
          query: {
            id: items.id
          }
        })
      } else if (items.relationorders && items.relationorders.length) {
        this.$router.push({ path: '/orderdetails', query: this.groupQuery({ id: items.relationorders[0].id }) })
      }
    },
    cancelFn: function (items) {
      var url = this.$ajax.cancelOrder_URL
      var data = {
        id: items.id
      }
      var that = this
      this.$dialog
        .confirm({
          message: '确认放弃优惠，取消订单吗？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          cancelButtonText: '确认取消',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '继续支付',
          closeOnPopstate: true
        })
        .then(function () {
          // on confirm
          that.goBuy(items)
        })
        .catch(function () {
          // on cancel
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.nowPage = 1
              that.getData()
            }
          })
        })
    },
    buyAgain: function (items, type) {
      var url = this.$ajax.addShoppingCart_URL
      var skuId = []
      var itemnum = []
      var liveId = []
      var list = items.item_list || items.itemlist
      if (type == 'after') {
        items.item_list.map((item) => {
          if (
            item.isgift == 0 &&
            !item.isadditem &&
            item.ischangebuy == 0 &&
            item.isexchangebuy == 0
          ) {
            skuId.push(item.skuid)
            itemnum.push(item.num)
            liveId.push(item.liveid)
          }
        })
      } else if (type == 'order') {
        items.itemlist.map((item) => {
          if (
            item.isgift == 0 &&
            !item.isadditem &&
            item.ischangebuy == 0 &&
            item.isexchangebuy == 0
          ) {
            skuId.push(item.skuid)
            itemnum.push(item.num)
            liveId.push(item.liveid)
          }
        })
      }
      var data = {
        skuid: skuId.join(),
        itemnum: itemnum.join(),
        live_ids: liveId.join()
      }
      if (!data.skuid.length) {
        this.$router.push('/cart')
        return
      }
      var that = this
      that.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          that.$store.commit('ADD_CART_INIT_DATA', 1)
          that.dataCollection(list)
          that.$router.push('/cart')
        }
      })
    },
    // 埋点-加入购物车
    dataCollection(list) {
      let params
      for (let i in list) {
        if (list[i].isgift == 0 && list[i].isadditem == 0 && list[i].ischangebuy == 0) {
          params = {
            productId_var: '',
            productName_var: list[i].name,
            firstCat_var: '',
            productType_var: '',
            productFormat_var: list[i].skuid
          }

          console.log(params)
          gio('track', 'addToCart', params)
        }
      }
    },
    // 去换购+加购
    goProductList(items) {
      let skuids = [],
        oid = items.id,
        obj
      items.itemlist.map((item) => {
        if (
          item.isgift == 0 &&
          item.isadditem == 0 &&
          item.isprogift == 0 &&
          item.ischangebuy == 0
        ) {
          skuids.push(item.skuid)
        }
      })
      localStorage.removeItem('shopConfirmResult')
      obj = {
        skuids: skuids.join(),
        type: 'orderInfo',
        oid: oid
      }
      if (items.isexchange == 1 && items.changebuystatus != 1) {
        obj.isexchange = 1
      }
      if (items.isexchange != 1 && items.changebuystatus == 1) {
        obj.changebuystatus = 1
      }
      this.$router.push({
        path: '/allProductList',
        query: obj
      })
    },
    checkTrans: function (items) {
      if (items.issplit == 0) {
        this.$router.push({
          path: '/logistics',
          query: {
            id: items.id
          }
        })
      } else if (items.issplit == 1) {
        this.$router.push({
          path: '/splitdetails',
          query: {
            id: items.id
          }
        })
      } else if (items.issplit == 2) {
        this.$router.push({
          path: '/splitdetails_order',
          query: {
            id: items.id
          }
        })
      }
    },
    navFn: function (item) {
      var that = this
      if (that.navClick != item.id) {
        that.navClick = item.id
        // 待支付弹窗提醒支付成功埋点清除
        sessionStorage.removeItem('unpaypopup-pay')
      } else {
        if (that && that.$refs.my_scroller) {
          // 通过vm实例访问this
          sessionStorage.askPositon = ''
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, true)
          }, 0) // 同步转异步操作
        }
      }
    },
    confirm: function (items, id) {
      var url = this.$ajax.confirmOrderItem_URL
      var data = {
        id: items.id
      }
      var that = this
      if (items.issplit == 1) {
        that.$router.push({
          path: '/splitdetails',
          query: {
            id: items.id
          }
        })
      } else {
        if (items.orderstatus == 2 && items.status == 3) {
          this.$dialog
            .alert({
              message: '您的包裹还没有全部发货，不能确认收货！',
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '知道了',
              closeOnPopstate: false
            })
            .then(function () {
              // on confirm
            })
            .catch(function () {
              // on cancel
            })
        } else {
          this.$dialog
            .confirm({
              message: '确认收货？',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              closeOnPopstate: true
            })
            .then(function () {
              that.$customRequestAjax.post(url, data).then((res) => {
                if (res.data.code === 200) {
                  if (res.data.noticmsg) that.$toast(res.data.noticmsg)
                  that.nowPage = 1
                  that.list = []
                  that.getData()
                }
              })
            })
            .catch(function () {
              // on cancel
            })
        }
      }
    },
    homeClick: function () {
      this.$router.push('/')
    },
    groupQuery: function (extra) {
      var query = extra || {}
      if (this.$route.query.actgroupid) {
        query.actgroupid = this.$route.query.actgroupid
      }
      if (this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex == 1) {
        query.isShowIndex = this.$route.query.isShowIndex
      }
      if (this.$route.query.newpersonhide) {
        query.newpersonhide = this.$route.query.newpersonhide
      }
      return query
    },
    searchClick: function () {
      this.$router.push({
        path: '/ordersearch',
        query: this.groupQuery()
      })
    },
    detailsClick: function (items) {
      if ((items.isdeposit != 1 && items.issubscribeorder != 1) || items.isvirtual == 0) {
        this.$router.push({ path: '/orderdetails', query: this.groupQuery({ id: items.id }) })
      }
    },
    afterDetailsClick: function (items) {
      if (items.order_type == 0) {
        this.$router.push({
          path: '/afterdetails',
          query: this.groupQuery({
            id: items.id
          })
        })
      } else {
        this.$router.push({
          path: '/orderdetails',
          query: this.groupQuery({
            id: items.order_id
          })
        })
      }
    },
    dateFn: function (date, type) {
      if (!date) return
      var arr = date.split(' ')
      var arrDateTime = arr[1].split(':')
      var arrDate = arr[0].split('-')
      if (type == 'datetime') {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日 ' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1] +
          '</span>'
        )
      } else if (type == 'datetimestr') {
        // return parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日' + arrDateTime[0] + ':' + arrDateTime[1]
        return (
          parseInt(arrDate[1]) +
          '月' +
          parseInt(arrDate[2]) +
          '日' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1]
        )
      } else if (type == 'datestr') {
        return (
          parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日'
        )
      } else {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日</span>'
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list ul li p,
.product {
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
.myOrd {
  header {
    background: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    transition: all 0.1s;
    /* &.ceiling {*/
    /*   top: -0.38rem;*/
    /*   z-index: 20;*/
    /*   background: #fff;*/
    /* }*/
    .searchBox {
      height: 0.44rem;
      background: #fff;
      padding: 0 0.11rem;
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      -moz-align-items: center;
    }
    .search {
      flex: 1;
      -webkit-flex: 1;
      -o-flex: 1;
      -ms-flex: 1;
      -moz-flex: 1;
      /*width: 3.23rem;*/
      margin-right: 0.1rem;
      height: 0.27rem;
      line-height: 0.25rem;
      font-size: 0.13rem;
      background: #f7f7f7;
      border-radius: 0.15rem;
      color: #999999;
      position: relative;
      .searchicon {
        font-size: 0;
        position: absolute;
        width: 0.2rem;
        height: 0.2rem;
        left: 0.1rem;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        /*overflow: hidden;*/
        .van-icon-search {
          color: transparent;
          font-weight: 600;
          font-size: 0.2rem;
          height: 100%;
          background: url('../../assets/images/search3.png') no-repeat center;
          background-size: 100%;
        }
      }
      .inp {
        border: 0.01rem solid transparent;
        background: transparent;
        border-radius: 0.15rem;
        height: 0.27rem;
        line-height: 0.25rem;
        padding-left: 0.35rem;
        font-size: 0.13rem;
        color: #999999;
        -webkit-transition: all 0.35s;
        transition: all 0.35s;
        margin-right: 0.1rem;
      }
    }
    ul {
      height: 0.45rem;
      padding: 0.14rem 0.11rem 0.06rem;
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      -webkit-justify-content: space-between;
      -o-justify-content: space-between;
      li {
        color: #4b4b4b;
        font-size: 0.14rem;
        padding-bottom: 0.05rem;
        border-bottom: 0.02rem solid transparent;
        font-weight: 400;
        &.colorLis {
          font-weight: 500;
          position: relative;
          /*border-bottom: 0.02rem solid #FC0324;*/
        }
        &.colorLis:after {
          content: '';
          display: block;
          width: 0.265rem;
          height: 0.025rem;
          background: linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1), rgba(255, 81, 104, 1));
          position: absolute;
          bottom: -0.02rem;
          left: 50%;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -ms-transform: translateX(-50%);
          -o-transform: translateX(-50%);
          /*border-bottom: 0.02rem solid #FC0324;*/
        }
      }
    }
  }
  .list {
    > ul {
      margin-bottom: 0.11rem;
      > li {
        background: #fff;
        margin: 0.11rem 0.11rem 0;
        padding: 0.15rem 0.15rem 0.2rem;
        > p {
          border-bottom: 1px solid #efefef;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size: 0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
                line-height: 0.19rem;
                float: left;
                img {
                  width: 0.19rem;
                  height: 0.19rem;
                  float: right;
                }
              }
            }
          }
          > b {
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            i {
              display: inline-block;
              font-style: normal;
              color: #292929;
              font-size: 0.12rem;
              line-height: 0.16rem;
              float: left;
              font-weight: 400;
            }
            b {
              display: inline-block;
              border-left: 1px solid #d8d8d8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              img {
                width: 0.12rem;
                height: 0.12rem;
              }
            }
          }
        }
        .product {
          margin-top: 0.16rem;
          position: relative;
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            .img {
              position: relative;
              img {
                &:first-of-type {
                  width: 100%;
                  height: 100%;
                }
              }
              width: 0.8rem;
              height: 0.8rem;
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              > b {
                font-size: 0.13rem;
                font-weight: 400;
                color: rgba(41, 41, 41, 1);
                line-height: 0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              > p {
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                > b {
                  font-size: 0.11rem;
                  font-weight: 400;
                  color: rgba(108, 108, 108, 1);
                  line-height: 0.16rem;
                  display: block;
                }
              }
            }
          }
          .totalPrice {
            position: absolute;
            right: -0.02rem;
            z-index: 10;
            opacity: 0.85;
            height: 0.8rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            &.totalPriceShadow {
              background: rgba(255, 255, 255, 1);
              box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
              -webkit-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
              -moz-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
              -ms-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
              -o-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            }
            & + .totalPriceNoShadow {
              background: rgba(255, 255, 255, 1);
            }
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight: 600;
              color: #222222;
              line-height: 0.14rem;
              &:before {
                content: '￥';
                font-size: 0.1rem;
                font-weight: 600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            > b {
              color: #908d8d;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight: 400;
              text-align: center;
              white-space: nowrap;
            }
          }
          .bestSellingSwiper {
            /*padding-right: 0.6rem;*/
            width: 100%;
            .swiper-container {
              padding-right: 0.6rem;
              .swiper-wrapper {
                > .swiper-slide {
                  width: 0.8rem;
                  position: relative;
                  background-color: white;
                  .img {
                    width: 0.8rem;
                    height: 0.8rem;
                    position: relative;
                    .tag {
                      position: absolute;
                      right: 0;
                      top: 0;
                      font-size: 0.12rem;
                      .van-tag {
                        border-radius: 0px 0px 0px 2px;
                      }
                    }
                    img {
                      &:first-of-type {
                        width: 100%;
                        height: 100%;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .proFooter {
          margin-top: 0.1rem;
          overflow: hidden;
          > .p {
            font-size: 0.1rem;
            font-weight: 400;
            color: rgba(252, 3, 36, 1);
            line-height: 0.26rem;
            float: left;
            &.q {
              color: #7b44f6;
              line-height: 0.14rem;
              width: 100%;
              height: 0.14rem;
              overflow: hidden;
              margin-bottom: 0.08rem;
              &.spread {
                height: auto;
                overflow: initial;
                margin-bottom: 0;
              }
              p {
                display: flex;
                display: -webkit-flex;
                display: -moz-flex;
                display: -ms-flex;
                display: -o-flex;
                align-items: center;
                -webkit-align-items: center;
                -moz-align-items: center;
                -ms-align-items: center;
                -o-align-items: center;
                justify-content: left;
                -webkit-justify-content: left;
                -moz-justify-content: left;
                -ms-justify-content: left;
                -o-justify-content: left;
                margin-bottom: 0.08rem;
                height: 0.14rem;
                span {
                  max-width: 100%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                &.spread {
                  height: auto;
                  overflow: initial;
                  margin-bottom: 0;
                  span {
                    max-width: initial;
                    white-space: initial;
                    overflow: initial;
                    text-overflow: initial;
                  }
                }
              }
            }
          }
          .proBtn {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            float: right;
            .grayBtn {
              white-space: nowrap;
              min-width: 0.7rem;
              height: 0.27rem;
              margin-left: 0.1rem;
              border-radius: 0.14rem;
              border: 1px solid rgba(96, 96, 96, 1);
              font-size: 0.12rem;
              font-weight: 400;
              color: rgba(38, 38, 38, 1);
              padding: 0.05rem 0.11rem;
              background: none;
              outline: none;
              display: flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -moz-flex;
              display: -o-flex;
              justify-content: center;
              -webkit-justify-content: center;
              -ms-justify-content: center;
              -o--justify-content: center;
              -moz--justify-content: center;
              align-items: center;
              -webkit-align-items: center;
              -o-align-items: center;
              -moz-align-items: center;
              -ms-align-items: center;
            }
            .redBtn {
              white-space: nowrap;
              min-width: 0.7rem;
              height: 0.27rem;
              line-height: 0.27rem;
              margin-left: 0.1rem;
              border-radius: 0.14rem;
              border: 1px solid #fc0324;
              font-size: 0.12rem;
              font-weight: 400;
              color: #fc0324;
              padding: 0 0.11rem;
              background: none;
              outline: none;
              display: flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -moz-flex;
              display: -o-flex;
              justify-content: center;
              -webkit-justify-content: center;
              -ms-justify-content: center;
              -o--justify-content: center;
              -moz--justify-content: center;
              align-items: center;
              -webkit-align-items: center;
              -o-align-items: center;
              -moz-align-items: center;
              -ms-align-items: center;
              &.grayBtn {
                border-color: #e3e3e3;
                color: #e3e3e3;
              }
              &.orangeBtn {
                border-color: #ffb346;
                color: #ffb346;
              }
            }
          }
        }
      }
    }
    .subscribe {
      background: #f9e7f1;
      color: #ff5c7b;
      border-radius: 0.12rem;
      padding-right: 0.1rem;
      height: 0.23rem;
      img {
        width: 0.6rem;
        height: 0.23rem;
      }
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.17rem;
    bottom: 0.8rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
  .empty {
    background: #fff;
    padding: 0.4rem 0 0.3rem;
    margin-top: 0.5rem;
    /*margin-bottom: 0.1rem;*/
    position: relative;
    z-index: 99;
    &.emptyNoProduct {
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -o-flex: 1;
      -ms-flex: 1;
    }
    img {
      width: 0.88rem;
      height: 0.88rem;
      margin: 0 auto 0.15rem;
    }
    p {
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(41, 41, 41, 1);
      line-height: 0.18rem;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.myOrd {
  display: flex;
  display: -webkit-flex;
  display: -o-flex;
  display: -moz-flex;
  display: -ms-flex;
  -webkit-flex-direction: column;
  -o-flex-direction: column;
  -moz-flex-direction: column;
  flex-direction: column;
  -ms-flex-direction: column;
  .scroller {
    padding-top: 0.87rem;
  }
  .van-count-down {
    font-size: 0.1rem;
    font-weight: 400;
    color: #fc0324;
    line-height: 0.14rem;
  }
  .subscribe .van-count-down {
    color: #ff5c7b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/myOrder.vue